import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { batchRequests } from '../../../utils/batch-requests';

type AttemptID = string;

export enum CRITERIA_MARK_VALUE {
    NO = 0,
    YES = 1,
}

export interface GetCriteriaMarksResponse {
    result: Record<AttemptID, CriteriaMark[]>;
}

export interface CriteriaMark {
    criterion_id: string;
    value: CRITERIA_MARK_VALUE;
}

export function getCriteriaMarksBatch(attempt_ids: AttemptID[]): Promise<GetCriteriaMarksResponse> {
    const { apiGetCriteriaMarks } = apiConfig.getStaticUrls();

    return getFetch(apiGetCriteriaMarks, { attempt_ids });
}

export const getCriteriaMarks = batchRequests(
    getCriteriaMarksBatch,
    (attemptId, batchResponse) => batchResponse.result[attemptId] || []
);
